import React from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UserPanelFormLayer from "../../components/UserPanelFormLayer";
import { useAuth } from "../../context/AuthContext";

const EditUserPanelPage = () => {
  const { id } = useParams();
  return (
    <MasterLayout>
      <Breadcrumb title="Edit User" />
      <UserPanelFormLayer mode="update" userId={id} />
    </MasterLayout>
  );
};

export default EditUserPanelPage;
